module.exports = __webpack_public_path__ + "static/media/101.d0ea1b8a.gif";